import services from './../services/service'; // Service Class
//import Preset from './preset.js';
let service = new services();

export default {
    name: 'Activity Resource',
    props: {
        currentActivity:Object,
    },
    //mixins: [Preset],
    data () {
      return {
        store_loading:false,
        activities:{},
        activity:{},
        //data-sets
        wishlist_store:{},
        saved_items_store:{},
        data_store0:{
            wishlist:{},
            saved_items:{}
        },
        data_store:[
            {db_id:1,db_name:"wishlistdbase",db_tag:"wishlist",data:{}},
            {db_id:2,db_name:"saveditemsdbase",db_tag:"saveditems",data:{}},
        ],
      }
  },

    methods: {
        getStoredActivities(){
            this.store_loading = true;
            //for each activities in store
            let count = 0;
            for(let store of this.data_store){
                let self = this;
                localforage.getItem(store.db_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                       // console.log(value)
                       self.data_store[count].data = value; 
                       // console.log(self.data_store[0])
                    }
                    count++;
                    if(count == self.data_store.length){
                        self.store_loading = false;
                    }
                });
            }
        },

        //

        getStoredActivity(store_name,store_id){
            //get store name
            if(store_name == ''){
                //set store name
                for(let store of service.store_db){
                    if(store_id == store.db_id){
                        store_name = store.db_name;
                    }
                }
            }
            let self = this;
            localforage.getItem(store_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    if(store_id == 9){
                        self.wishlist_store = value;
                    }else if(store_id == 10){
                        self.saved_items_store = value;
                    }
                }
            });
        },

        storeActivity(store_name,store_id,store_data){
            if(store_name == ''){
                //set store name
                for(let store of service.store_db){
                    if(store_id == store.db_id){
                        store_name = store.db_name;
                    }
                }
            }
            //set data and set at local if needs forage store
            if(store_name != ''){ 
                localforage.setItem(store_name,store_data).then(function (value) {}).catch(function(err) {});
            }
        },

        getActivity(){
            //setts
            localforage.removeItem("activity_data_store");
            //../

            //set payload
            var payload = {
                activity: this.activity.activity_id || 0,
                //ams-model
                activity_module_action_type: this.activity.activity_module_action_type || 0,
                activity_module_data: this.activity.activity_module_data || 0,
            }
            service.regActivity(this, payload).then(response => {
                if(response.body.status == 200) {
                    let set_data = response.body.data;
                    //activity store
                    this.storeActivity('activity_data_store',0,set_data);
                    //specific activity data store
                    let data_store_id = this.activity.activity_data_store_id;
                    if(data_store_id > 0){
                        this.storeActivity('',data_store_id,set_data);   
                    }
                }
            }).catch((err) => {})
        },

        setActivity(){
            if((this.activity.activity_module > 0) && (this.activity.activity_module_id > 0) && (this.activity.activity_user_module > 0) && (this.activity.activity_user_module_id > 0)){
                //set payload
                var payload = {
                    activity_record_activity: this.activity.activity_record_activity || 0,
                    activity_user_module: this.activity.activity_user_module,
                    activity_user_module_id: this.activity.activity_user_module_id,
                    activity_activity: this.activity.activity_id || 0,
                    activity_action_type: this.activity.activity_action_type || 0,//post activity
                    activity_module: this.activity.activity_module,
                    activity_module_id: this.activity.activity_module_id,
                    activity_caption: this.activity.activity_caption || '',
                    //ams-model
                    activity_module_action_type: this.activity.activity_module_action_type || 0,
                    activity_module_data: this.activity.activity_module_data || 0,
                }
                service.regActivity(this, payload).then(response => {
                    if(response.body.status == 201) {
                        let set_data = response.body.data;
                        let data_store_id = this.activity.activity_data_store_id;
                        this.storeActivity('',data_store_id,set_data);
                    }
                }).catch((err) => {})
            }
        },

     
    },
    created: function(){
        this.getStoredActivities();
    }
}


// WEBPACK FOOTER //
// ./src/resources/activity.js